import { render } from "./NpcCard.vue?vue&type=template&id=576ac7db"
import script from "./NpcCard.vue?vue&type=script&lang=js"
export * from "./NpcCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__